export default "__VITE_ASSET__CGWRgQeP__"